import React from "react";
import PropTypes from "prop-types";

// Formik
import { Form, Formik } from "formik";

// Material
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import ButtonBase from "@material-ui/core/ButtonBase";

// Config
import colors from "../../config/colors";
import useTranslate from "../../hooks/useTranslate";

// Components
import Button from "../Button";
import Text from "../Text";
import CustomField from "../CustomField";
import Close from "../Close";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4, 3, 5),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: 465
  },
  buttonClose: {
    display: "flex",
    marginLeft: "auto",
    padding: theme.spacing(2)
  },
  heading: {
    marginBottom: theme.spacing(2),
    textAlign: "left",
    width: "100%"
  },
  form: {
    width: "100%"
  },
  button: {
    minWidth: 144,
    height: 40,
    marginTop: theme.spacing(2)
  }
}));

const canSubmit = values => !!values.referenceNumber?.trim();

const EditReferenceNumberDialog = ({
  initialValue,
  isSaving,
  onClose,
  onSave
}) => {
  const classes = useStyles();
  const getText = useTranslate();

  const handleSubmit = values => {
    onSave(values.referenceNumber.trim());
  };

  return (
    <Dialog onClose={onClose} open>
      <div className={classes.root}>
        <ButtonBase className={classes.buttonClose} onClick={onClose}>
          <Close size={16} color={colors.riverBed} />
        </ButtonBase>
        <Text
          type="heading3"
          className={classes.heading}
          text="common.prompts.editReferenceNumber"
        />
        <Formik initialValues={{ referenceNumber: initialValue }} onSubmit={handleSubmit}>
          {({ values }) => (
            <Form className={classes.form}>
              <CustomField
                autoComplete="off"
                name="referenceNumber"
                placeholder={getText(
                  "createCasePage.formContent.crimeReferenceLabel"
                )}
              />
              <Button
                className={classes.button}
                disableElevation
                disabled={isSaving || !canSubmit(values)}
                fullWidth
                variant="contained"
                type="submit"
                color="primary"
              >
                {getText("common.prompts.save")}
              </Button>
            </Form>
          )}
        </Formik>
      </div>
    </Dialog>
  );
};

EditReferenceNumberDialog.propTypes = {
  initialValue: PropTypes.string.isRequired,
  isSaving: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};

EditReferenceNumberDialog.defaultProps = {
  isSaving: false
};

export default EditReferenceNumberDialog;
